import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const claimRequest = (data, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/claim-request', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const claimRequestBOL = (data, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/claim-request-bol', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const returnAuthorization = (data, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/return-authorization', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const pickupRequest = (data, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/resolution/claim_resolved', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const rejectRequest = (data, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/claim/reject-request', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};

export const claimRaised = (token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/order/claim-raised', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const claimRejected = (token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/api/order/claim-received-rejected', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const claimResolved = (token, loader) => (dispatch) => {
    if (loader !== 'skipLoading') dispatch(showAppLoader());
    return axioPath
        .get('/api/order/claim-received-resolved', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    if (loader !== 'skipLoading') dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            if (loader !== 'skipLoading') dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const claimPending = (token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/api/order/claim-received-pending', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const claimReceived = (token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/order/claim-received', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};

export const imageDisplay = (image, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/order/image/' + image, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};

export const receivedClaimMessage = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/user_message', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    // dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
}

export const updateReceivedClaimMessage = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/update_user_message', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    // dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
}

export const receivedClaimMessageForAdmin = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/admin_message', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    // dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
}

export const updateReceivedClaimMessageForAdmin = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/update_admin_message', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    // dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
}
export const postClaimMessage = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/user_chat', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
}

export const postClaimMessageForAdmin = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/admin_chat', data, {
            headers: {
                Authorization: `${token}`
            },
        }).then((response) => {
            setTimeout(
                () => {
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        }).catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
}

export const chatMessageCount = (data, token) => (dispatch) => {
    return axioPath
        .post('/order/resolution_chat/msg_count', data, {
            headers: {
                Authorization: `${token}`
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    // dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
}


